import fiveLogoImg from '/images/5ka-logo.webp'
import appGlassImg from '/images/app_glass.webp'
import crossImg from '/images/cross.webp'
import qrCodeImg from '/images/qr_code.webp'
import {
  createFiveBrowserDeeplink,
  createPerekrestokDeeplink,
} from '@el5/native-api'

import type { EsumOfferViewProps } from './EsumOfferView'

const baseGameUrl = `${import.meta.env.VITE_ENV_BASE_GP_HOST}/gameprelauch/esum`

const sharedCarouselItems: EsumOfferViewProps['carouselItems'] = [
  {
    number: 2,
    text: 'Сканируйте специальный QR код в магазине',
    image: qrCodeImg,
  },
  {
    number: 3,
    text: 'Выполните задание и получите баллы «X5 Клуба» в награду',
    image: crossImg,
  },
]

export const esumVariants: Record<string, EsumOfferViewProps> = {
  tc5: {
    buttonText: 'Пятёрочка',
    buttonVariant: 'primaryRed',
    buttonHref: 'https://5ka.ru/app',
    accentColor: 'var(--brand-5ka-color)',
    deeplink: createFiveBrowserDeeplink({
      type: 'presentModal',
      url: baseGameUrl,
      modes: {
        isStatusBarHidden: false,
        isDisabledSafeAreaInsets: false,
        customBackPressedHandle: true,
        isLandscapeOrientationEnabled: false,
      },
    }),
    carouselItems: [
      {
        number: 1,
        text: 'Установите приложение «Пятёрочка»',
        image: fiveLogoImg,
      },
      ...sharedCarouselItems,
    ],
  },
  tcx: {
    buttonText: 'Перекрёсток',
    buttonVariant: 'primaryGreen',
    buttonHref: 'https://perekrestok.ru/app',
    accentColor: 'var(--brand-color)',
    deeplink: createPerekrestokDeeplink({
      type: 'local_webview',
      url: baseGameUrl,
      isDebugApp: import.meta.env.VITE_ENV_NAME !== 'prod',
    }),

    carouselItems: [
      {
        number: 1,
        text: 'Установите приложение «Перекрёсток»',
        image: appGlassImg,
      },
      ...sharedCarouselItems,
    ],
  },
}
